<template>
  <div class="wrapp-cart-badge cart-item">
    <button class="wrapp-cart-icon btn btn-icon btn-icon-small" :class="{ 'has-item' : badgeCount, 'btn-rounded btn-icon-border-black': useRoundedIcon, 'btn-none': !useRoundedIcon }" @click.prevent="showMiniCart">
      <div class="d-inline-flex position-relative">
        <div class="cart-badge">{{ badgeCount }}</div>
        <svg class="o-icon fill-black"><use xlink:href="#cart"></use></svg>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CartBadge',
  props: {
    useRoundedIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    badgeCount () {
      return this.$store.getters['cart/badge']
    }
  },
  methods: {
    showMiniCart () {
      this.$emit('clicked')
      const componentToLoad = import('theme/components/Cart/MiniCart')
      this.$store.dispatch('ui/loadBottomActiveComponent', { component: componentToLoad })
    }
  },
  mounted () {
    if (this.$route.query.openCart) {
      this.showMiniCart()
    }
  }
}
</script>
